export default "__VITE_ASSET__393454cb__"